import { Form, Table } from 'react-bootstrap';

function OtherDependentsTable() {

    return (
        <div className="container">
            <div className="row">
                <div >
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>Other Group Medical Coverage Information
                                    (only list those covered by other plan)</th>
                                <th style={{ width: "20%" }}>Type (B/S/F)*</th>
                                <th style={{ width: "10%" }}>Effective Date</th>
                                <th style={{ width: "10%" }}>End Date</th>
                                <th style={{ width: "30%" }}>Name & Date of Birth of
                                    policyholder for other coverage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><Form.Control id={`otherCoverageName_0`} type="text" name="name" className='my-2' placeholder="Primary Name" /></td>
                                <td><Form.Select id={`otherCoverageType_0`} name="type" className='my-2'>
                                    <option hidden value="">Choose B/S/F</option>
                                    <option value="B">B</option>
                                    <option value="S">S</option>
                                    <option value="F">F</option>
                                </Form.Select>
                                </td>
                                <td><Form.Control id={`otherCoverageEffDate_0`} type="date" name="effdate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageEndDate_0`} type="date" name="enddate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageNameAndDob_0`} type="text" name="dob" className='my-2' placeholder='Enter other coverage' /></td>
                            </tr>
                            <tr>
                                <td><Form.Control id={`otherCoverageName_1`} type="text" name="name" className='my-2' placeholder="Dependent Name" /></td>
                                <td><Form.Select id={`otherCoverageType_1`} name="type" className='my-2'>
                                    <option value="">N/A</option>
                                </Form.Select></td>
                                <td><Form.Control id={`otherCoverageEffDate_1`} type="date" name="effdate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageEndDate_1`} type="date" name="enddate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageNameAndDob_1`} type="text" name="dob" className='my-2' placeholder='Enter other coverage' /></td>
                            </tr>
                            <tr>
                                <td><Form.Control id={`otherCoverageName_2`} type="text" name="name" className='my-2' placeholder="Dependent Name" /></td>
                                <td><Form.Select id={`otherCoverageType_2`} name="type" className='my-2'>
                                    <option value="">N/A</option>
                                </Form.Select></td>
                                <td><Form.Control id={`otherCoverageEffDate_2`} type="date" name="effdate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageEndDate_2`} type="date" name="enddate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageNameAndDob_2`} type="text" name="dob" className='my-2' placeholder='Enter other coverage' /></td>
                            </tr>
                            <tr>
                                <td><Form.Control id={`otherCoverageName_3`} type="text" name="name" className='my-2' placeholder="Dependent Name" /></td>
                                <td><Form.Select id={`otherCoverageType_3`} name="type" className='my-2'>
                                    <option value="">N/A</option>
                                </Form.Select></td>
                                <td><Form.Control id={`otherCoverageEffDate_3`} type="date" name="effdate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageEndDate_3`} type="date" name="enddate" className='my-2' /></td>
                                <td><Form.Control id={`otherCoverageNameAndDob_3`} type="text" name="dob" className='my-2' placeholder='Enter other coverage' /></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div className="col-sm-4">
                </div>
            </div>
        </div>
    )
}

export default OtherDependentsTable
